$.fn.beforeImgLoad = function (callback) {
    var img = $(this);

    var wait = setInterval(function(){
        var w = img.width(),
            h = img.height();

        if (!img.hasClass("lazyload")) {
            if(w && h){
                done(w, h);
            }
        }
    }, 0);

    var onLoad;
    img.on('load', onLoad = function(){
        done(img.width(), img.height());
    });


    var isDone = false;
    function done(){
        if(isDone){
            return;
        }
        isDone = true;

        clearInterval(wait);
        img.off('load', onLoad);

        callback.apply(this, arguments);
    }
};